<template>
  <div>
    <v-card v-if="editing" outline :loading="loading">
      <v-card-text>
        <v-textarea v-model="text" auto-grow outlined />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn
          text 
          color="warning"
          :disabled="this.text == this.review.review"
          @click="reset"
        >Reset</v-btn>
        <v-btn
          text
          :loading="loading"
          :disabled="this.text == this.review.review"
          :color="this.text ? 'success' : 'error'"
          @click="submit"
        >{{ this.text ? 'Submit' : 'Delete' }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="review.review" outlined>
      <v-card-title>
        <i>Your Review</i>
        <v-spacer/>
        <v-btn text x-small @click="edit">Edit</v-btn>
      </v-card-title>
      <v-card-subtitle>
        <v-rating
          v-if="review.rating || review.rating === 0"
          dense
          readonly
          x-small
          length="10"
          :value="review.rating"
        />
        <small>{{ $moment(review.created).fromNow() }}</small>
      </v-card-subtitle>
      <v-card-text>{{ review.review }}</v-card-text>
    </v-card>
    <v-btn v-else text width="100%" @click="edit">Add Your Review</v-btn>
  </div>
</template>

<script>
export default {
  name: "MyReview",
  props: {
    film_id: {
      type: Number | String,
      required: true,
    },
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
      loading: false,
      text: this.review.review,
    }
  },
  inject: ["httpClient"],
  methods: {
    edit() {
      this.editing = true
    },
    cancel() {
      if (this.loading) return
      this.editing = false
    },
    reset() {
      if (this.loading) return
      this.text = this.review.review
    },
    async submit() {
      if (this.loading) return
      this.loading = true
      const data = await this.httpClient.updateReview({
        id: this.film_id,
        review: this.text,
      })
      if (data.result == "deleted") {
        this.$emit("deleteReview", {
          id: this.film_id,
        })
      } else if (data.result == "updated") {
        this.$emit("updateReview", {
          id: this.film_id,
          review: data.review,
        })
      } else {
        this.$emit("addReview", {
          id: this.film_id,
          review: data.review,
        })
      }
      this.loading = false
      this.editing = false
    },
  },
}
</script>
